import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

/** One shimmering bar. Compose to match the content's shape. */
export const Skeleton = ({ className }: { className?: string }) => (
    <div aria-hidden="true" className={clsx('skeleton h-3', className)} />
);

/** true after `ms` of being mounted: skeletons appear only for slow responses. */
export const useDelayed = (ms = 150): boolean => {
    const [late, setLate] = useState(false);
    useEffect(() => {
        const id = window.setTimeout(() => setLate(true), ms);
        return () => window.clearTimeout(id);
    }, [ms]);
    return late;
};

/** Wrapper for a loading region: aria-busy, hidden "Loading…", children shown after 150 ms. */
export const SkeletonRegion = ({ children, className }: { children: React.ReactNode; className?: string }) => {
    const { t } = useTranslation();
    const late = useDelayed();
    return (
        <div aria-busy="true" className={className}>
            <span className="sr-only">{t('ui.loading')}</span>
            {late && children}
        </div>
    );
};
